<style scoped>
.menu-dragbox{display: flex; justify-content: center;align-items:center;overflow-y:auto;}
</style>
<template>
    <div id="sponsor-edit-tab-resource">
        <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mt-2">
            <div class="custom-head-wrap mb-5">
              <h1 class="cms-custom-heading">
                  {{data_local.Name}}
              </h1>
            </div>
            <div class="custom-head-wrap mb-5">

                  <h2 class="cms-custom-heading">
                      Upload Resources
                  </h2>
            </div>
            <!-- <h3>Upload Resources</h3>
            <label>Supported File types: .csv, .excel,.xlsx,.pdf,.doc,.docx</label> -->
            <div class="vx-row">
            <div class="vx-col md:w-1/2 mt-6 ">
                <div class="upload-area-wrap sponsor-upload-wrap">
                <input type="file" multiple class="hidden" ref="update_resource_input" @change="upload_resources" >
                <vs-button class="mr-4 mb-4" @click="$refs.update_resource_input.click()">Upload Resources</vs-button>
                </div>
            </div>
            <div class="vx-col md:w-1/2 mb-3 ">
                <label>Uploaded Resources (Drag and drop to reorder)</label>
                <div class="resourse-file-list-wrap sponsor-file-upload-wrap">
                  <draggable :list="data_local.Resources" :group="{name: 'tags'}" class="p-2 cursor-move menu-dragbox">
                    <div v-if="data_local.Resources.length">  
                      <div class="single-file-wrap" v-for="file in data_local.Resources">
                        <div class="file-sec-wrap">
                          <a :href="file.name ? '#' : file" >{{ file.name ? file.name : getFileName(file) }}</a> 
                          <a href="#"><img @click="deleteFile(file)" src="../../assets/images/delete.svg" /></a>
                        </div>
                      </div>
                    </div>
                    <div v-else>No Resources uploaded yet!</div>
                  </draggable>
                </div>
            </div>
            </div>
        </div> 
        </div>
        <!-- Save & Reset Button -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class=" mt-2" @click="$router.push('/event/sponsors')">Back To List</vs-button>
              <vs-button
                class="ml-auto mt-2"
                @click="save_changes"
                color="success"
              >Save & Exit</vs-button>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor'
import draggable from "vuedraggable";

import moduleSponsorManagement from '@/store/sponsor-management/moduleSponsorManagement.js'

export default {
  components: {
    vSelect,
    quillEditor,
    draggable
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc: this.data.Logo,
      ResourceFiles: []

    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    before_save()
    {
       this.$validator.validateAll().then(result => {
        if(result) {
          // if form have no errors
          this.save_changes();
        }
      })
    },
    deleteFile(file){
      let name = ''
      if(file.name)
      {
        name = file.name
      }
      else
      {
        name = file
        const Id = this.$route.params.sponsorId
        if (Id) {
          this.$vs.loading();
          this.$store.dispatch('sponsorManagement/deleteResource', { id: Id, name: name})
            .then(res => {               
              this.$vs.loading.close()  
              let index = this.data.Resources.indexOf(name);
              this.data.Resources.splice(index, 1)
            }).catch(err => {          
            console.error(err) 
            })
        }
      }
      let index = this.data_local.Resources.indexOf(name);
      this.data_local.Resources.splice(index, 1)
      let index2 = this.ResourceFiles.indexOf(name);
      this.ResourceFiles.splice(index2, 1)
    },
    getFileName(downloadUrl){
      let url = decodeURIComponent(downloadUrl)
      let arr = url.split('?');
      let arr2 = arr[0].split('/')
      let name = arr2[arr2.length - 1]
      return name
    },
    upload_resources(input)
    {
      if (input.target.files.length) { 
        for(var i = 0; i < input.target.files.length ; i++) {
          const file = input.target.files[i]
          const metadata = {
            'contentType': file.type
          }     
          //console.log(file)
          let  filename = file.name
          filename = filename.split('.').pop();
          //console.log(filename) 
          /*const validImageTypes = ['csv', 'pdf', 'xlsx', 'excel', 'doc', 'docx']
          if (!validImageTypes.includes(filename)) {
            alert('Only files allowed.')
            return false
          }*/
          let FileSize = file.size / 1024 / 1024;
          if(FileSize > 20)
          {
            alert("Uploaded file size exceeds 20 MB");
            return false;
          }
          this.data_local.Resources.push(file)
          this.ResourceFiles.push(file)          
        }        
      }
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

        this.$vs.loading()
      this.data_local.ResourceFiles = this.ResourceFiles
      this.ResourceFiles = []
      const Id = this.$route.params.sponsorId
      //alert(Id);
      if (Id) {
        this.$store.dispatch('sponsorManagement/updateSponsor', { id: Id, data: this.data_local})
          .then(res => { 
            //alert(res.message)          
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Sponsor",
              text: "Sponsor resource updated successfully.",
            });
            this.$vs.loading.close();
            this.$router.push("/event/sponsors/");
          }).catch(err => {          
          console.error(err) 
          })
      } else {
        this.$store.dispatch('sponsorManagement/addSponsor', { data: this.data_local})
          .then(res => { 
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Sponsor",
              text: "Sponsor resource created successfully.",
            });
            this.$vs.loading.close();
            if (res.status == 200) {          
              this.$router.push('/event/sponsors/');             
            }            
          }) 
          .catch(err => {          
          //console.error(err) 
          })
      }
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
    
  },
  created () {
    
  }


}
</script>
